import request from '@/config/axios'

export interface CatalogCityVO {
  id?: number
  name?: string
  code?: string
  province?: string
  status?: number
  sort?: number
  remark?: string
}

export const CatalogCityApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/catalog/city/page', params })
  },
  getOpenedList: async () => {
    return await request.get({ url: '/o2o/catalog/city/list-opened' })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/catalog/city/get?id=' + id })
  },
  create: async (data: CatalogCityVO) => {
    return await request.post({ url: '/o2o/catalog/city/create', data })
  },
  update: async (data: CatalogCityVO) => {
    return await request.put({ url: '/o2o/catalog/city/update', data })
  },
  updateStatus: async (data: { id: number; status: number }) => {
    return await request.put({ url: '/o2o/catalog/city/update-status', data })
  }
}
